'use client'

import React, { createContext, useCallback, use, useEffect } from 'react'

import type { Theme, ThemeContextType } from './types'
import { defaultTheme } from './shared'

const initialContext: ThemeContextType = {
    setTheme: () => null,
}

const ThemeContext = createContext(initialContext)

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
    // There are no states for theming because there is limited theming and any
    // styling theme should be handled with tailwind dark selector
    const setTheme = useCallback((themeToSet: Theme) => {
        document.documentElement.setAttribute('data-theme', themeToSet)
    }, [])

    useEffect(() => {
        // Set the default theme if there is no theme set
        if (!document.documentElement.getAttribute('data-theme')) {
            document.documentElement.setAttribute('data-theme', defaultTheme)
        }
    }, [])

    return <ThemeContext value={{ setTheme }}>{children}</ThemeContext>
}

export const useTheme = (): ThemeContextType => use(ThemeContext)
